import { useQuery } from "@tanstack/react-query";
import { getProposalsSdk } from "../graphql/client/proposals";
import { useMatch } from "@tanstack/react-location";
import { useEnvConfig } from "./useEnvConfig";
export const useQueryProposals = () => {
    const { route, pathname } = useMatch();
    const config = useEnvConfig();
    return useQuery(["governance.getProposals"], async () => {
        const { getProposals } = await getProposalsSdk();
        return await getProposals({ project: config.project });
    }, {
        enabled: route.path === pathname,
        suspense: true,
        cacheTime: 30000, // 30 seconds
    });
};
//# sourceMappingURL=useQueryProposals.js.map